import { Box, Divider, Typography, Avatar, Button, Input } from '@mui/material';
import { StylesForm } from '../../../styles/global';
import AdvancedModal from '../../AdvancedModal';
import { useState } from 'react';
import { sendMessage } from '../../../utils/API';
import { useFeedback } from '../../../utils/FeedbackContext';
export default function InformInbox({
  project,
  refresh,
  setRefesh,
  editMode = false,
}) {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const { notifyError, notifySuccess } = useFeedback();
  const send = async () => {
    try {
      const response = await sendMessage(project._id, { message });
      console.log(response.data.data);
      notifySuccess('Message Sent Successfully');
      setRefesh(!refresh);
    } catch (error) {
      console.error('Error sending message:', error);
      notifyError('Error Sending Message. Please Try Again');
    }
    setOpen(false);
  };

  const inbox = project?.inbox ? [...project.inbox].reverse() : [];

  return (
    <>
      {project && (
        <>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            {/* Project Title */}
            <Typography {...StylesForm.text('h6')}>Project Inbox</Typography>
            {editMode ? (
              <Button onClick={() => setOpen(true)}>Send Message</Button>
            ) : (
              <Typography {...StylesForm.text('p')}>
                {project?.inbox?.length} Messages
              </Typography>
            )}
          </Box>

          <Divider sx={{ marginX: 1 }} />

          {inbox.length > 0 && (
            <Box overflow={'auto'} width={'100%'}>
              {inbox.map((message, index) => (
                <Box key={index}>
                  <Box sx={{ display: 'flex', alignItems: 'start' }} mt={1}>
                    <Avatar
                      sx={{ width: 27, height: 27, marginRight: 1 }}
                    ></Avatar>
                    <Box>
                      <Typography
                        {...StylesForm.text('p')}
                        color="darkslategray"
                      >
                        <strong>{message.sender}</strong>
                      </Typography>

                      <Typography
                        {...StylesForm.text('subtitle2')}
                        color="darkslategray"
                      >
                        {message.message}
                      </Typography>
                    </Box>
                  </Box>
                  <Divider sx={{}} />
                </Box>
              ))}
            </Box>
          )}
          <AdvancedModal
            open={open}
            title={'Send Message'}
            cta={'Send'}
            handleSave={send}
            handleClose={() => setOpen(false)}
          >
            <Box
              sx={{
                padding: 2,
                border: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
              }}
            >
              <Typography>Send a message to the project owners:</Typography>
              <Input
                variant={'contained'}
                placeholder={'Write your message here'}
                fullWidth
                multiline
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </Box>
          </AdvancedModal>
        </>
      )}
    </>
  );
}
